var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAngle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "angle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,10H14a4.9509,4.9509,0,0,0-1.2325-3.2723L14.23,5.2655l-3.4651-.8,2.0773-2.1153-.7139-.7012L0,14H15.9971V13H14.125ZM2.3838,13,9.8974,5.3488l.7967,3.4522,1.3621-1.362A3.95363,3.95363,0,0,1,13,10H11l1.875,3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAngle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/angle.c9314f8370d413d3b19daff1434cab8b.svg";